import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api";
import router from "@/router/index";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : []
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.admin('exp', data, {})
                .then((response) => {
                    store.commit("admin/item", response.data.data)
                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.admin('post', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
    },

    getters: {
        item(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
